/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationState } from './OrganizationState';
import {
    OrganizationStateFromJSON,
    OrganizationStateFromJSONTyped,
    OrganizationStateToJSON,
} from './OrganizationState';

/**
 * 
 * @export
 * @interface FindAllOrganizationStates200Response
 */
export interface FindAllOrganizationStates200Response {
    /**
     * 
     * @type {Array<OrganizationState>}
     * @memberof FindAllOrganizationStates200Response
     */
    data?: Array<OrganizationState>;
}

/**
 * Check if a given object implements the FindAllOrganizationStates200Response interface.
 */
export function instanceOfFindAllOrganizationStates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllOrganizationStates200ResponseFromJSON(json: any): FindAllOrganizationStates200Response {
    return FindAllOrganizationStates200ResponseFromJSONTyped(json, false);
}

export function FindAllOrganizationStates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationStates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(OrganizationStateFromJSON)),
    };
}

export function FindAllOrganizationStates200ResponseToJSON(value?: FindAllOrganizationStates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(OrganizationStateToJSON)),
    };
}

